<template>
  <Drawer
    class="city-drawer"
    show="{{value}}"
    bind:close="onClose"
    title="{{title}}"
    closeable
    showMask
    centerTitle
    headerStyle="{{headerStyle}}"
  >
    <CityList class="city-container" bizType="{{bizType}}" bindconfirm="cityConfirm" />
  </Drawer>
</template>

<script>
  import { createComponent } from '@mpxjs/core'

  export const px2vw = (px) => `${(px / 750) * 100}vw`

  createComponent({
    props: {
      value: {
        type: Boolean,
        value: false
      },
      bizType: {
        type: String,
        value: 'train', // flights
      },
      title: {
        type: String,
        value: '',
      },
    },
    data: {
      headerStyle: {
        paddingTop: px2vw(30),
        paddingBottom: px2vw(20),
        fontWeight: 500,
        fontSize: px2vw(36),
        color: '#000',
      }
    },
    methods: {
      onClose() {
        this.triggerEvent('input', {
          value: false
        })
      },
      cityConfirm({ detail }) {
        this.onClose()
        this.triggerEvent('confirm', detail)
      }
    }
  })
</script>

<style lang="stylus" scoped>
.city-drawer
  >>> .drawer-container
    height 85vh
    .header
      font-family PingFangSC-Medium
      font-weight 500
  .city-container
    >>> .search.mpx-input
      border none
      outline none
</style>

<script name='json'>
  module.exports = {
    usingComponents: {
      'Drawer': '@didi/spring-ui/ts-drawer',
      'CityList': '@didi/spring-ui/citySelect'
    }
  }
</script>
